export default "__VITE_PUBLIC_ASSET__f4720474__"